import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    /*
    watch: {
        'yMax': "reset"
    },
    methods: {
        reset () {
            if(this._chart) this._chart.destroy()
            this.renderChart(this.chartData, this.options)
        }
    },
    */
    computed: {
        options () {
            return {
                tooltips: {
                    displayColors: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const raw_data = data.raw_data[tooltipItem.index]
                            return [
                                `Prospective: ${numeral(raw_data.prospective).format("0,0")}`,
                                `Active: ${numeral(raw_data.active).format("0,0")}`,
                                `Balance: ${numeral(tooltipItem.value).format("0,0")}%`
                            ]
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            // suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: function (value, index, values) {
                                return `${numeral(value).format("0,0")}%`
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontSize: 10,
                            fontColor: "#00274F"
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: false,
                    position: "bottom",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        yMax: {
            type: Number,
            default: 0
        }
    }
})
